import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
declare var $: any;
@Component({
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss']
})
export class PositionComponent implements OnInit {
  obj_data_all: any = [];
  obj_data: any = {};
  constructor(private util: UtilService
    , private apiService: ApiService) { }

  ngOnInit() {
    let that = this;
    var table = $('#tData').DataTable({
      "aaSorting": [],
      'columnDefs': [

        {
          'targets': 5,
          'searchable': false,
          'orderable': false,
          "className": "text-center",
          'render': function (data: any, type: any, full: any, meta: any) {
            return '<i name="delete" class="fa fa-close" style="color: red; cursor: pointer " role="' + data + '"></i>';
          }
        }]
    });

    $('#tData tbody').on('click', 'tr', function () {
      that.InitEdit(table.row(this).data()[0]);
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
      } else {
        table.$('tr.selected').removeClass('selected');
        $(this).addClass('selected');
      }
    });


    $('#tData tbody').on('click', 'i', function () {
      var r = confirm("ยืนยันลบข้อมูล : " + $(this).attr('role'));
      if (r == true) {
        that.Delete($(this).attr('role'));
      }

    });
  }


  async  Search() {
    this.obj_data_all = {};
    var table = $('#tData').DataTable();
    table.clear().draw();
    let that = this;
    this.util.ShowWaiting(true);
    var data = {}
    data["position_code"] = $('#txtID').val();
    data["position_desc"] = $('#txtDesc').val();
    data["status"] = $('#ddlStatus').val();


    var res: any = await this.apiService.post('master', 'GetPosition', data);
    this.util.ShowWaiting(false);
    if (res.isSuccess) {
      if (res.responseData != null) {
        if (res.responseData.length > 0) {
          this.obj_data_all = res.responseData;
          for (var i = 0; i < res.responseData.length; i++) {

            var status = '';
            if (res.responseData[i].status == 1) {
              status = "ใช้งาน";
            } else {
              status = "ไม่ใช้งาน";
            }

            table.row.add(
              [res.responseData[i].position_code,
              res.responseData[i].position_desc,
                status,
              this.util.DisPlayDate(res.responseData[i].update_date),
              res.responseData[i].update_user,
              res.responseData[i].position_code]).draw();
          }


        }
      }

    }
  }

  Add() {
    this.ClearDlg();
    $("#txtMode").val('A');
    $('#txtDlgID').prop('disabled', false);
    $('#dlgData').modal({
      backdrop: 'static',
      keyboard: false
    })
  }
  InitEdit(x: string) {
    this.obj_data = {};
    if (this.obj_data_all != null) {
      if (this.obj_data_all.length > 0) {
        for (var i = 0; i < this.obj_data_all.length; i++) {
          if (x == this.obj_data_all[i].position_code) {
            $('#txtDlgID').val(this.obj_data_all[i].position_code);
            $('#txtDlgDesc').val(this.obj_data_all[i].position_desc);
            $('#ddlDlgStatus').val(this.obj_data_all[i].status);
            this.obj_data = this.obj_data_all[i];

            break;
          }
        }
      }
    }
  }
  Edit() {
    $("#txtMode").val('E');
    $('#txtDlgID').prop('disabled', true);
    if ($('#txtDlgID').val() != '' && $('#txtDlgID').val() != null
      && $('#txtDlgID').val() != 'null') {
      $('#dlgData').modal({
        backdrop: 'static',
        keyboard: false
      })
    }
  }
  ClearDlg() {
    $('#tData tbody tr.selected').removeClass('selected');
    this.obj_data = {};
    $('#txtDlgID').val('');
    $('#txtDlgDesc').val('');
    $('#txtDlgDescEn').val('');
    $('#ddlDlgStatus').val('1');
  }

  async Delete(x: any) {

    let that = this;
    var data = {};
    data["position_code"] = x;

    var res: any = await this.apiService.post('master', 'DeletePosition', data);
    if (res != null) {
      if (res.isSuccess) {
        this.util.SuccessDialog('บันทึกสำเร็จ');
        this.Search();
      } else {
        this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
      }
    } else {
      this.util.ErrorDialog('System Error');
    }


  }

  async Save() {
    if (this.util.ValidateForm()) {
      var data = {};
      if ($("#txtMode").val() == 'A') {
        data["POSITION_CODE"] = $('#txtDlgID').val();
        data["POSITION_DESC"] = $('#txtDlgDesc').val();
        data["STATUS"] = $('#ddlDlgStatus').val();
        data["CREATE_USER"] = this.util.GetUserID();
        data["UPDATE_USER"] = this.util.GetUserID();
      } else {
        data = this.obj_data;
        data["POSITION_DESC"] = $('#txtDlgDesc').val();
        data["STATUS"] = $('#ddlDlgStatus').val();
        data["UPDATE_USER"] = this.util.GetUserID();
      }

      var res: any = await this.apiService.post('master', 'InsertUpdatePosition', data, $("#txtMode").val());
      if (res != null) {
        if (res.isSuccess) {
          this.util.SuccessDialog('บันทึกสำเร็จ');
          $('#dlgData').modal('hide');
          this.ClearDlg();
          this.Search();
        } else {
          this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
        }
      } else {
        this.util.ErrorDialog('System Error');
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/member/position/position.component.ts